<template>
    <v-toolbar app class="primary"  dark clipped-left>
        <v-flex xs4>
            <v-toolbar-side-icon 
                aria-label="OpenMenu" 
                @click.stop="drawer()"
                v-show="isMobile"
            ></v-toolbar-side-icon>
        </v-flex>
        <v-flex xs12>
            <v-toolbar-title class="pt-1">
                <h1>{{$route.meta.title}}</h1>
            </v-toolbar-title>
        </v-flex>
        <v-flex xs4 style="text-align:right">
        </v-flex>     
    </v-toolbar>
</template>

<script>
export default {
    name: 'Toolbar',
    data(){
        return {
            almanaccoImageUrl:null,
            almanaccoDescription: null,
            showAlmanaccoDialog: false
        };
    },
    computed: {
        appTitle () {
            let vm = this;
            return vm.$store.state.app.title
        }
    },
    methods: {
        drawer () {
            let vm = this;
            vm.$store.commit('drawer', !vm.$store.state.app.drawer)
        },
    },
    mounted(){
        let vm=this;
    }
}
</script>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Kalam:wght@300&display=swap');
</style>